<template lang="pug">
  .loading
    Frame(mod="center")
      .loading__scale-cont
        .loading__player(ref="player", :style="'left: ' + playerLeft + 'px;'")
        .loading__scale(ref="scale")
          .loading__points(:style="'width: ' + pointsWidth + 'px;'")
      .loading__percent Загрузка {{ percent }}%
</template>

<script>
import Frame from '@/components/UI/Frame';

const POINT_WIDTH = 11;

export default {
  name: 'Loading',
  props: ['percent'],
  components: { Frame },
  mounted() {
    this.scaleWidth = this.$refs.scale.offsetWidth;
    this.playerWidth = this.$refs.player.offsetWidth;
    // TODO: вешать на ресайз обновление загрузки (+пересчёт playerLeft и pointsWidth)
  },
  computed: {
    playerLeft() {
      const left = (this.percent * this.scaleWidth) / 100;
      return left <= this.playerWidth ? left : left - this.playerWidth;
    },
    pointsWidth() {
      const maxPointsWidth = this.scaleWidth - (2 * POINT_WIDTH);
      const maxPoints = maxPointsWidth / POINT_WIDTH;
      const currentPointsWidth = Math.round(maxPoints / (100 / this.percent)) * POINT_WIDTH;

      return currentPointsWidth < maxPointsWidth ? currentPointsWidth : maxPointsWidth;
    },
  },
  data() {
    return {
      scaleWidth: 0,
      playerWidth: 0,
    };
  },
};
</script>

<style scoped lang="scss">
  $point-width: 11px;
  $point-height: 14px;

  .loading {
    z-index: z('header');
    position: absolute;
    @media (max-width: $max-width-xs) {
      width: 100%;
    }
    &__scale {
      @include retina-sprite($loading-scale-group);
      @media (max-width: $max-width-xs) {
        @include retina-sprite($loading-scale-xs-group);
      }
      &-cont {
        position: relative;
      }
    }
    &__points {
      position: absolute;
      top: 50px;
      left: $point-width;
      bottom: 10px;
      background: url(~@/assets/loading__point.png) repeat-x left center;
      background-size: $point-width $point-height;
      @include player-trans;
      @media (max-width: $max-width-xs) {
        top: 40px;
        bottom: 7px;
      }
    }
    &__player {
      position: absolute;
      top: 16px;
      left: 0;
      @include retina-sprite($loading-car-group);
      @include player-trans;
      @media (max-width: $max-width-xs) {
        top: 12px;
        @include retina-sprite($loading-car-xs-group);
      }
    }
    &__percent {
      @include typo-button;
      color: $clr-main;
      margin: 20px 0 0;
      @media (max-width: $max-width-xs) {
        @include typo-text;
        margin: 24px 0 0;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Interface/Loading.vue